module.exports = __webpack_public_path__ + "static/media/close-circle.46c03b12.svg";